import { css } from '@emotion/core'
import { smallOnly, mediumUp } from 'Utils'
import theme from 'Theme'

export default () => {
  const { typography, colors, spacing, mixins } = theme

  const { mainContainerTopPadding, mainContainerMaxWidth } = mixins
  return css`
    ${mainContainerTopPadding(theme)}
    min-height: 100vh;
    padding-bottom: 65px;
    position: relative;

    .feedback {
      display: flex;
      justify-content: space-between;
      @media ${mediumUp} {
        width: 100%;
        display: grid;
        grid-gap: 1rem;
        grid-template-areas: 'applied-filters applied-filters applied-filters items-found';
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }

    .items-found {
      grid-area: items-found;
    }

    .applied-filters {
      grid-area: applied-filters;
    }

    .product-list-wrapper {
      min-height: 80vh;
    }

    .product-list-wrapper,
    .feedback {
      ${mainContainerMaxWidth(theme)}
    }

    .product-list-actions,
    .product-list,
    .slot {
      margin-bottom: ${spacing.base_3}px;
    }

    .items-found {
      @media ${mediumUp} {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
      }
    }

    .applied-filters {
      @media ${smallOnly} {
        margin-bottom: ${spacing.base_1}px;
        max-width: 95%;
        margin: 0 auto;
      }
    }

    .no-search-wrapper {
      padding: 100px 0;
    }

    .no-search-results {
      margin: 1.6rem auto;
      max-width: 320px;
      text-align: center;
    }

    .heading {
      text-transform: uppercase;
      text-align: center;
      font-weight: normal;
      font-size: ${typography.sizes.larger};
      margin-bottom: ${spacing.base_1}px;
    }

    .heading-term {
      grid-area: heading-term;
      text-align: center;
    }

    .search-term {
      font-size: ${typography.baseFontSize};
      font-weight: bold;
    }

    .panel-trigger {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      @media ${smallOnly} {
        margin-bottom: ${spacing.base_3}px;
      }
    }

    &:hover {
      .panel-trigger__icon {
        fill: ${colors.purple};
      }
      .panel-trigger__text {
        color: ${colors.purple};
      }
    }

    .panel-trigger__icon {
      display: inline-block;
    }

    .panel-trigger__text {
      display: inline-block;
      margin-left: 12px;
    }

    .progress {
      display: table;
      margin: 0 auto ${spacing.base_2}px auto;
    }

    .load-more-button {
      position: absolute;
      bottom: ${spacing.base_3}px;
      left: 50%;
      transform: translateX(-50%);
    }
  `
}
